import * as RadioGroup from '@radix-ui/react-radio-group';
import { memo } from 'react';
import { classNames } from '~/utils/classNames';

interface SurveyRadioItemProps {
  value: string;
  id: string;
  className?: string;
  children: React.ReactNode;
}

export const SurveyRadioItem = memo<SurveyRadioItemProps>(({ value, id, children, className }) => (
  <RadioGroup.Item
    className={classNames(
      'bg-bolt-ds-surfaceTwo border border-bolt-ds-borderOutline rounded-lg px-4 min-h-12  [&[data-state=checked]]:bg-bolt-ds-surfaceThree [&[data-state=checked]]:border-bolt-ds-brand [&[data-state=checked]]:ring-1 [&[data-state=checked]]:ring-bolt-ds-brand hover:bg-bolt-ds-surfaceThree transition-theme',
      className,
    )}
    value={value}
    id={id}
  >
    {children}
  </RadioGroup.Item>
));
